/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gray_Teal_Hare_MeltInputs */

const en_gray_teal_hare_melt = /** @type {(inputs: Gray_Teal_Hare_MeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load the shared content`)
};

const de_gray_teal_hare_melt = /** @type {(inputs: Gray_Teal_Hare_MeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden der geteilten Inhalte fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Could not load the shared content" |
*
* @param {Gray_Teal_Hare_MeltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gray_teal_hare_melt = /** @type {((inputs?: Gray_Teal_Hare_MeltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gray_Teal_Hare_MeltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gray_teal_hare_melt(inputs)
	return de_gray_teal_hare_melt(inputs)
});